import { Col, Container, Row, Card } from "react-bootstrap";
import { useState } from "react";

export const Articles = () => {
  const [articles] = useState([
    {
      id: 1,
      title: "Working Of DNS (Domain Name System)",
      description:
        "A comprehensive guide to understanding the Domain Name System (DNS) and its role in the internet infrastructure.",
      publishDate: "Feb 16, 2025",
      readTime: "3 min read",
      tags: ["Networking", "DNS", "Internet"],
      mediumUrl:
        "https://medium.com/@rahulsingh8556kumar/working-of-dns-domain-name-system-6104f75c346d",
      imageUrl:
        "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*la498szWOqlvS9ZbP1ywpQ.gif",
    },
    {
      id: 2,
      title: "Understanding of the SoftAP & Captive Portal",
      description:
        "Smart devices use SoftAP, turning into a temporary Wi-Fi hotspot. You connect via phone, enter Wi-Fi details on a captive portal, and the device securely joins your network for seamless app integration.",
      publishDate: "Apr 26, 2025",
      readTime: "2 min read",
      tags: [
        "Software Development",
        "Embedded Software",
        "IoT",
        "Software",
        "WiFi",
      ],
      mediumUrl:
        "https://medium.com/@rahulsingh8556kumar/understanding-of-the-softap-captive-portal-24ff7167ba3a",
      imageUrl:
        "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*bkqQmbKXvCyZV23M_ra8CQ.png",
    },
    {
      id: 3,
      title: "Advanced Networking Concepts",
      description:
        "Deep dive into advanced networking protocols and their implementation in modern web applications.",
      publishDate: "Jan 15, 2025",
      readTime: "5 min read",
      tags: ["Networking", "Protocols", "Web Development"],
      mediumUrl:
        "https://medium.com/@rahulsingh8556kumar/advanced-networking-concepts",
      imageUrl:
        "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*la498szWOqlvS9ZbP1ywpQ.gif",
    },
  ]);

  return (
    <section>
      <Container fluid  >
        <Container className="home-content">
          <Row>
            <Col md={12} className="home-header">
              <h1 className="heading-name">
                My Technical Articles
                <strong className="main-name"> & Insights</strong>
              </h1>
              <p
                style={{
                  color: "white",
                  fontSize: "1.2em",
                  paddingLeft: "45px",
                  marginTop: "20px",
                }}
              >
                Sharing knowledge and experiences in software development
              </p>
            </Col>
          </Row>

          <Row style={{ marginTop: "50px" }}>
            {articles.map((article) => (
              <Col
                md={6}
                lg={4}
                key={article.id}
                style={{ marginBottom: "30px" }}
              >
                <a
                  href={article.mediumUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ textDecoration: "none" }}
                >
                  <Card
                    className="article-card"
                    style={{
                      backgroundColor: "transparent",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      borderRadius: "10px",
                      transition: "all 0.3s ease",
                      height: "100%",
                      boxShadow: "none",
                    }}
                  >
                    <Card.Img
                      variant="top"
                      src={article.imageUrl}
                      alt={article.title}
                      style={{
                        height: "200px",
                        objectFit: "cover",
                        borderRadius: "10px 10px 0 0",
                      }}
                    />
                    <Card.Body style={{ padding: "20px" }}>
                      <Card.Title
                        style={{
                          color: "white",
                          fontSize: "1.3em",
                          fontWeight: "600",
                          marginBottom: "15px",
                          lineHeight: "1.4",
                        }}
                      >
                        {article.title}
                      </Card.Title>

                      <Card.Text
                        style={{
                          color: "rgba(255, 255, 255, 0.8)",
                          fontSize: "0.95em",
                          lineHeight: "1.6",
                          marginBottom: "15px",
                        }}
                      >
                        {article.description}
                      </Card.Text>

                      <div style={{ marginBottom: "15px" }}>
                        {article.tags.map((tag, index) => (
                          <span
                            key={index}
                            style={{
                              display: "inline-block",
                              backgroundColor: "rgba(196, 67, 224, 0.2)",
                              color: "#c443e0",
                              padding: "4px 8px",
                              borderRadius: "15px",
                              fontSize: "0.8em",
                              marginRight: "8px",
                              marginBottom: "5px",
                              border: "1px solid rgba(196, 67, 224, 0.3)",
                            }}
                          >
                            {tag}
                          </span>
                        ))}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          color: "rgba(255, 255, 255, 0.6)",
                          fontSize: "0.85em",
                        }}
                      >
                        <span>
                          {new Date(article.publishDate).toLocaleDateString(
                            "en-US",
                            {
                              year: "numeric",
                              month: "short",
                              day: "numeric",
                            }
                          )}
                        </span>
                        <span>{article.readTime}</span>
                      </div>
                    </Card.Body>
                  </Card>
                </a>
              </Col>
            ))}
          </Row>

          <Row style={{ marginTop: "40px" }}>
            <Col md={12} style={{ textAlign: "center" }}>
              <a
                href="https://medium.com/@rahulsingh8556kumar"
                style={{
                  color: "#c443e0",
                  textDecoration: "none",
                  fontSize: "1.1em",
                  fontWeight: "600",
                  padding: "12px 30px",
                  border: "2px solid #c443e0",
                  borderRadius: "25px",
                  transition: "all 0.3s ease",
                  display: "inline-block",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#c443e0";
                  e.target.style.color = "white";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "#c443e0";
                }}
              > 
                View All Articles on Medium →
              </a>
            </Col> 
          </Row>
        </Container>
      </Container>
    </section>
  );
};
